import { ContentSection, DataOverview, DescriptionList } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { useMatchMakerWizard } from "../../hooks/useMatchMakerWizard";
import { DealerData } from "../../interfaces/IDealerData";
import { BrandType } from "@bus/models";

import { capitalizeBrand } from "../../helpers/capitalizeBrand";

export const DealerInformation = () => {
    const { t } = useTranslation(["summarypage"]);

    const { goToDealerStep, dealersList, submitAnswersRequest, defaultDealer } = useMatchMakerWizard();
    const { selectedDealer } = submitAnswersRequest;

    const dealerSeleted: DealerData | undefined = dealersList.find((x) => x.id === selectedDealer) ?? defaultDealer;
    const brand = process.env.REACT_APP_WEBSITE_BRAND;

    const getTitle = () => {
        switch (brand as BrandType) {
            case BrandType.VWN:
                return t("summarypage:dealer-information.titleVWN")
            case BrandType.VW:
                return t("summarypage:dealer-information.titleVW")
            case BrandType.AUDI:
                return t("summarypage:dealer-information.titleAudi")
            default:
                return t("summarypage:dealer-information.title", {
                    brand: capitalizeBrand(brand as BrandType),
                })
        }
    }

    return (
        <ContentSection.ComponentWrapper>
            <DataOverview
                href=""
                titleLevel={2}
                title={getTitle()}
                buttonLabel={t("summarypage:edit")}
                buttonProps={{
                    id: "DealerInformationSummaryEditButton",
                    onClick: (e) => {
                        e.preventDefault();
                        goToDealerStep(true);
                    },
                    tabIndex: 0,
                }}
                id="DealerInformationSummary"
            >
                {dealerSeleted && (
                    <DescriptionList grid>
                        <DescriptionList.Group termText={
                            brand === "audi" ? t("summarypage:dealer-information.nameAudi") :
                                t("summarypage:dealer-information.name")}>
                            <DescriptionList.Detail id="DealerInformationName">
                                {dealerSeleted.name}
                            </DescriptionList.Detail>
                        </DescriptionList.Group>
                        <DescriptionList.Group termText={
                            brand === "audi" ? t("summarypage:dealer-information.addressAudi") :
                                t("summarypage:dealer-information.address")}>
                            <DescriptionList.Detail id="DealerInformationAddress">
                                {dealerSeleted.street} {dealerSeleted.houseNumber} <br /> {dealerSeleted.zip}{" "}
                                {dealerSeleted.city}
                            </DescriptionList.Detail>
                        </DescriptionList.Group>
                    </DescriptionList>
                )}
            </DataOverview>
        </ContentSection.ComponentWrapper>
    );
};
